export { default } from "./SlackBadge";
